import { useEffect } from "react";

// Sets document.title while the component is mounted and restores the previous one on unmount
export const useDocumentTitle = (title) => {
  useEffect(() => {
    const previous = document.title;
    document.title = title;
    return () => {
      document.title = previous;
    };
  }, [title]);
};
